import {
  ChangeDetectionStrategy,
  Component,
  Renderer2,
  ViewEncapsulation,
} from '@angular/core';
import { BottomNavigationEntryInterface } from '../../interfaces/bottom-navigation-entry.interface';
import { HeaderService } from '../../services/header.service';

@Component({
  selector: 'cp-bottom-navigation',
  templateUrl: './bottom-navigation.component.html',
  styleUrls: ['./bottom-navigation.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BottomNavigationComponent {
  public readonly navOptions: Array<BottomNavigationEntryInterface> = [
    {
      routerLink: '/dashboard',
      svgId: 'home',
      svgIconClassName: 'icon-bottom-nav--dashboard',
      label: 'Dashboard',
    },
    {
      routerLink: '/compliance',
      svgId: 'tasks',
      svgIconClassName: 'icon-bottom-nav--compliance',
      label: 'Compliance',
    },
    {
      routerLink: '/profile',
      svgId: 'id-card',
      svgIconClassName: 'icon-bottom-nav--profile',
      label: 'Profile',
    },
    {
      routerLink: '/training',
      svgId: 'contact-book',
      svgIconClassName: 'icon-bottom-nav--training',
      label: 'Training',
    },
  ];

  constructor(
    private _headerService: HeaderService,
    private _renderer2: Renderer2,
  ) {}

  public closeNavigation(): void {
    this._headerService.closeNavigation(this._renderer2, document);
  }
}
